import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../store'
import { isMobile } from 'react-device-detect'
import { RecognitionState } from '../../models/enums'

const FocusManager = (): JSX.Element => {
  const dispatch = useDispatch()
  const isWidget = useSelector((state: RootState) => state.viewReducer.isWidget)
  const open = useSelector((state: RootState) => state.widgetReducer.open)
  const muted = useSelector((state: RootState) => state.speechReducer.muted)
  const activeRecognitionState = useSelector((state: RootState) => state.speechReducer.activeRecognitionState)

  const focusedRef = useRef<boolean>(true)
  const oldMutedRef = useRef<boolean>(muted)
  const recognitionStateRef = useRef<RecognitionState>(activeRecognitionState)

  useEffect(() => {
    focusedRef.current && (oldMutedRef.current = muted)
  }, [muted])

  useEffect(() => {
    recognitionStateRef.current = activeRecognitionState
  }, [activeRecognitionState])

  useEffect(() => {
    if (isMobile && isWidget) {
      if (open) {
        focusedRef.current = true
        oldMutedRef.current === false && dispatch(storeActions.speech.setMuted(false))
      } else {
        focusedRef.current = false
        dispatch(storeActions.speech.cancelCurrentUtterance())
        dispatch(storeActions.speech.setMuted(true))
        recognitionStateRef.current === RecognitionState.Listening && dispatch(storeActions.speech.setActiveRecognitionState(RecognitionState.ForceClosing))
      }
    }
  }, [open, isWidget, isMobile])

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      focusedRef.current = true
      oldMutedRef.current === false && dispatch(storeActions.speech.setMuted(false))
    } else {
      focusedRef.current = false
      dispatch(storeActions.speech.cancelCurrentUtterance())
      dispatch(storeActions.speech.setMuted(true))
      recognitionStateRef.current === RecognitionState.Listening && dispatch(storeActions.speech.setActiveRecognitionState(RecognitionState.ForceClosing))
    }
  }

  useEffect(() => {
    isMobile && document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [isMobile])

  return <React.Fragment />
}

export default FocusManager
